import { Container } from "../../core/render/Container";
import { p100 } from "../../core/util/Percent";
/**
 * A base class for all charts.
 */
export class Chart extends Container {
    constructor() {
        super(...arguments);
        /**
         * A [[Container]] chart places its elements in.
         *
         * @default Container.new()
         */
        this.chartContainer = this.children.push(Container.new(this._root, { width: p100, height: p100, interactiveChildren: false }));
        /**
         * A [[Container]] chart places its bullets in.
         *
         * @default Container.new()
         */
        this.bulletsContainer = Container.new(this._root, { interactiveChildren: false, isMeasured: false, position: "absolute", width: p100, height: p100 });
    }
}
Chart.className = "Chart";
Chart.classNames = Container.classNames.concat([Chart.className]);
//# sourceMappingURL=Chart.js.map